import CircularProgress from '@mui/material/CircularProgress';

export interface SpinnerProps {
  size?: string;
}

export function Spinner({ size = '24px' }: SpinnerProps) {
  return <CircularProgress style={{ margin: '0 auto' }} color="inherit" size={size} />;
}
